import React from 'react'
import { Button } from '@design-systems/canvas-ui'
import { SectionGuide } from '../../../../globalComponents/RfiCommons'
import Rfi3TabsBar from './Rfi3TabsBar'
import Rfi3SectionContent from './Rfi3SectionContent'

const Rfi3Body = ({
  rfi3Template,
  rfi3Data,
  auditData,
  rfiMasterData,
  isReadonly,
  activeTab,
  activeRFI3Section,
  setActiveRfi3Section,
  errorCache,
  gotoPreviousSection,
  gotoNextSection,
  saveRfi3Payload,
  statusColorMapper,
  productCapabilityDialogSettings,
  setProductCapabilityDialogSettings,
  isRfi3SaveInProgress,
  isRfi3SaveFailed,
  isTabErrored,
  getTabIdByName,
  setActiveTab,
}) => {
  if (!rfi3Template || !rfi3Data) return null

  const tabs = rfi3Template.dynamic_sections?.tabs || []
  const currentTab = tabs[activeTab.index]
  const sections = currentTab?.sections || []
  const currentSection = sections[activeRFI3Section.index]
  const isNonCompliantOrArchived = rfi3Data?.non_compliant || rfi3Data?.archived

  return (
    <div
      className="width-100 hc8-mt-2x"
      style={{
        height: isNonCompliantOrArchived ? '75vh' : '80vh',
        overflowY: 'scroll',
        overflowX: 'hidden',
        marginBottom: '40px',
      }}
    >
      <Rfi3TabsBar
        rfi3Template={rfi3Template}
        rfi3Data={rfi3Data}
        auditData={auditData}
        rfiMasterData={rfiMasterData}
        statusColorMapper={statusColorMapper}
        activeTab={activeTab}
        setActiveTab={setActiveTab}
        productCapabilityDialogSettings={productCapabilityDialogSettings}
        setProductCapabilityDialogSettings={setProductCapabilityDialogSettings}
        isTabErrored={isTabErrored}
      />

      <div className="hc8-mh-4x hc8-pb-4x hc8-bg-base">
        <div className="hc8-ph-4x hc8-pt-4x">
          <SectionGuide
            steps={sections}
            focusStep={activeRFI3Section.name}
            updateFocusStep={(stepName) => {
              const sectionIndex = sections.findIndex(
                (eachSection) => eachSection.section_name === stepName,
              )
              if (sectionIndex >= 0) {
                setActiveRfi3Section({
                  index: sectionIndex,
                  uid: sections[sectionIndex].uid,
                  name: stepName,
                })
              }
            }}
            errorCache={errorCache}
          />
        </div>

        <Rfi3SectionContent
          rfi3Template={rfi3Template}
          rfi3Data={rfi3Data}
          rfiMasterData={rfiMasterData}
          isReadonly={isReadonly}
          activeTab={activeTab}
          activeRFI3Section={activeRFI3Section}
          errorCache={errorCache}
          saveRfi3Payload={saveRfi3Payload}
          getTabIdByName={getTabIdByName}
        />

        <div className="hc8-ma-4x align-self-right">
          {(currentSection?.isBackVisible ?? true) && (
            <Button
              className="button-back hc8-mr-4x section-button-thin"
              variant="secondary"
              size="md"
              isDisabled={isRfi3SaveInProgress || isRfi3SaveFailed}
              onClick={gotoPreviousSection}
            >
              Back
            </Button>
          )}

          {(currentSection?.isNextVisible ?? true) && (
            <Button
              className="button-back section-button-thin"
              variant="primary"
              size="md"
              isDisabled={isRfi3SaveInProgress || isRfi3SaveFailed}
              onClick={gotoNextSection}
            >
              Next
            </Button>
          )}
        </div>
      </div>
    </div>
  )
}

export default React.memo(Rfi3Body)
